export enum TerminalStatus {
  ALL = 'ALL',
  AVAILABLE = 'AVAILABLE',
  LINKED = 'LINKED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TEST = 'TEST',
  SUPPORT = 'SUPPORT',
}

export type TerminalFilterStatus =
  | TerminalStatus.ALL
  | TerminalStatus.AVAILABLE
  | TerminalStatus.LINKED
  | TerminalStatus.ACTIVE
  | TerminalStatus.INACTIVE
  | TerminalStatus.TEST
  | TerminalStatus.SUPPORT;

export type TerminalRecordStatus =
  | TerminalStatus.AVAILABLE
  | TerminalStatus.LINKED
  | TerminalStatus.ACTIVE
  | TerminalStatus.INACTIVE
  | TerminalStatus.TEST
  | TerminalStatus.SUPPORT;

export interface ISelectedModel {
  id: number;
  name: string;
}

export interface ITerminalListFilters {
  page: number;
  limit: number;
  status?: TerminalRecordStatus[];
  serialNumbers?: string[];
  barteCompanyIds?: number[];
  companyName?: string;
  barteSellerIds?: number[];
  sellerName?: string;
}

export type TransactionalStatus = 'ACTIVE' | 'LATE' | 'INACTIVE';

export interface ITerminalListItem {
  id: number;
  serialNumber: string;
  companyUuid?: string | null;
  sellerId?: number | null;
  status: TerminalRecordStatus;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  posCompanyName?: string | null;
  companyId?: number | null;
  posCompanyId?: number | null;
  posSellerId?: number | null;
  posSellerName?: string | null;
  posSellerExternalId?: string | null;
  posTerminalExternalId?: string | null;
  transactionalStatus?: TransactionalStatus | null;
  lastTransactionAt?: string | null;
  linkedAt?: string | null;
}

export interface ITerminalListPageable {
  page: number;
  limit: number;
  totalRecords: number;
  totalPages: number;
}

export interface ITerminalListResponse {
  data: ITerminalListItem[];
  pageable: ITerminalListPageable;
}

export interface ICreateTerminalPayload {
  model: number;
  serialNumbers: string[];
}

export interface ICreateTerminalResultItem {
  serialNumber: string;
  status: string;
}

export interface ICreateTerminalResponse {
  success: ICreateTerminalResultItem[];
  errors: ICreateTerminalResultItem[];
}

export interface IPOSCompanyItem {
  id: number;
  name: string;
  posCompanyId: number;
}

export interface IPageSort {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export interface IPageableInfo {
  sort: IPageSort;
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

export interface IPOSSellerItem {
  id: number;
  name: string;
  posSellerId: number;
}

export interface ITerminalCurrentLink {
  payfacName?: string | null;
  payfacExternalId?: string | null;
  sellerName?: string | null;
  sellerExternalId?: string | null;
  linkedAt?: string | null;
  lastTransactionAt?: string | null;
}

export interface IAllocationHistoryItem {
  payfacName?: string | null;
  sellerName?: string | null;
  linkedAt?: string | null;
  unlinkedAt?: string | null;
}

export interface ITerminalDetails {
  serialNumber: string;
  status: TerminalRecordStatus;
  posVersion?: string | null;
  phoebusId?: string | null;
  createdAt?: string | null;
  testedAt?: string | null;
  currentLink?: ITerminalCurrentLink | null;
  allocationHistory?: IAllocationHistoryItem[];
}

export interface ICsvBatchRow {
  serialNumber: string;
  payfacId?: number | null;
  sellerId?: number | null;
}

export interface IResolveNamesPayload {
  payfacIds?: number[];
  sellerIds?: number[];
}

export interface IResolvedNameItem {
  id: number;
  name: string;
}

export interface IResolveNamesResponse {
  payfacs?: IResolvedNameItem[];
  sellers?: IResolvedNameItem[];
}

export interface IConfigureAssignment {
  sellerId?: number;
  serialNumbers: string[];
}

export interface IConfigureTerminalPayload {
  payfacId: number;
  assignments: IConfigureAssignment[];
}

export interface IConfigureTerminalResultItem {
  serialNumber: string;
  status: string;
  previousPayfacId?: number | null;
  actualPayfacId?: number | null;
  previousPayfacName?: string | null;
  actualPayfacName?: string | null;
  previousSellerId?: number | null;
  actualSellerId?: number | null;
  previousSellerName?: string | null;
  actualSellerName?: string | null;
}

export interface IConfigureTerminalResponse {
  success: IConfigureTerminalResultItem[];
  errors: IConfigureTerminalResultItem[];
}

export interface IUnconfigureTerminalPayload {
  serialNumbers: string[];
}

export interface ICsvBatchPayload {
  file: File;
  processingType: string;
}
